<template>
  <div class="w-full h-full flex-row justify-center align-center">
    <PhSparkle size="128" color="#dddddd" />
  </div>
</template>

<script lang="ts" setup>
import { PhSparkle } from '@phosphor-icons/vue'
</script>
